var r="4.13.1";export{r as version};
//# sourceMappingURL=package.json.js.map
